// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.main .chat-box {
  width: 100%;
  height: 100%;
  position: relative;
  background: #f9fbfc;
}
.main .chat-box .message-area {
  max-height: 90%;
  height: 90%;
  overflow: auto;
  padding: 15px 10px;
}
.main .chat-box .message-area .message .message-content {
  color: var(--ion-color-primary-contrast);
  font-size: 0.8125rem;
  max-width: 95%;
  min-width: 55%;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 15px 10px 7px;
  margin: 5px 0;
  background: var(--ion-color-primary);
}
.main .chat-box .message-area .message .message-content ion-text {
  display: block;
}
.main .chat-box .message-area .message .message-content ion-text.username {
  margin-bottom: 0.25rem;
  font-weight: bold;
}
.main .chat-box .message-area .message .message-content ion-text.text {
  margin-bottom: 0.5rem;
}
.main .chat-box .message-area .message .message-content ion-text.datetime {
  font-size: 0.7rem;
  color: var(--ion-color-light-shade);
}
.main .chat-box .message-area .message.incoming, .main .chat-box .message-area .message.outgoing {
  display: flex;
  flex-direction: column;
}
.main .chat-box .message-area .message.incoming {
  justify-content: flex-start;
  align-items: flex-start;
}
.main .chat-box .message-area .message.incoming .message-content {
  border-radius: 0 11px 11px 11px;
  background: #a50064;
}
.main .chat-box .message-area .message.outgoing {
  justify-content: flex-end;
  align-items: flex-end;
}
.main .chat-box .message-area .message.outgoing .message-content {
  border-radius: 11px 11px 0 11px;
}
.main .chat-box .emo-area {
  position: absolute;
  bottom: 50px;
  left: 0;
  width: 100%;
  padding: 3px 10px;
}

.input-area {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: white;
}
.input-area form {
  display: flex;
  height: 100%;
  padding-left: 0.5rem;
  padding-bottom: 0.75rem;
}
.input-area form ion-input {
  width: 82%;
  border: none;
  padding: 5px 10px;
  color: #8a898b;
  font-size: 14px;
  font-weight: bold;
  font-family: "Titillium Web", sans-serif;
  background: inherit;
}
.input-area form ion-input:focus {
  outline: none;
}
.input-area form button {
  width: 18%;
  border: none;
  color: #8a898b;
  opacity: 0.9;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: inherit;
}
.input-area form button ion-icon {
  font-size: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/chat/chat.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AADJ;AAGI;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AADN;AAIQ;EACE,wCAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;EACA,0CAAA;EACA,2BAAA;EACA,aAAA;EACA,oCAAA;AAFV;AAIU;EACE,cAAA;AAFZ;AAIY;EACE,sBAAA;EACA,iBAAA;AAFd;AAKY;EACE,qBAAA;AAHd;AAMY;EACE,iBAAA;EACA,mCAAA;AAJd;AASQ;EAEE,aAAA;EACA,sBAAA;AARV;AAWQ;EACE,2BAAA;EACA,uBAAA;AATV;AAWU;EACE,+BAAA;EACA,mBAAA;AATZ;AAaQ;EACE,yBAAA;EACA,qBAAA;AAXV;AAaU;EACE,+BAAA;AAXZ;AAiBI;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;AAfN;;AAsBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAnBF;AAqBE;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;AAnBJ;AAqBI;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,wCAAA;EACA,mBAAA;AAnBN;AAqBM;EACE,aAAA;AAnBR;AAuBI;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AArBN;AAuBM;EACE,iBAAA;AArBR","sourcesContent":["// src/components/chat/chat.scss\n\n.main {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n\n  .chat-box {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    background: #f9fbfc;\n\n    .message-area {\n      max-height: 90%;\n      height: 90%;\n      overflow: auto;\n      padding: 15px 10px;\n\n      .message {\n        .message-content {\n          color: var(--ion-color-primary-contrast);\n          font-size: 0.8125rem;\n          max-width: 95%;\n          min-width: 55%;\n          box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n          padding: 10px 15px 10px 7px;\n          margin: 5px 0;\n          background: var(--ion-color-primary);\n\n          ion-text {\n            display: block;\n\n            &.username {\n              margin-bottom: .25rem;\n              font-weight: bold;\n            }\n\n            &.text {\n              margin-bottom: .5rem;\n            }\n\n            &.datetime {\n              font-size: .7rem;\n              color: var(--ion-color-light-shade);\n            }\n          }\n        }\n\n        &.incoming,\n        &.outgoing {\n          display: flex;\n          flex-direction: column;\n        }\n\n        &.incoming {\n          justify-content: flex-start;\n          align-items: flex-start;\n\n          .message-content {\n            border-radius: 0 11px 11px 11px;\n            background: #a50064;\n          }\n        }\n\n        &.outgoing {\n          justify-content: flex-end;\n          align-items: flex-end;\n\n          .message-content {\n            border-radius: 11px 11px 0 11px;\n          }\n        }\n      }\n    }\n\n    .emo-area {\n      position: absolute;\n      bottom: 50px;\n      left: 0;\n      width: 100%;\n      padding: 3px 10px;\n    }\n  }\n}\n\n// src/components/chat/chat.scss\n\n.input-area {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: white;\n\n  form {\n    display: flex;\n    height: 100%;\n    padding-left: 0.5rem;\n    padding-bottom: .75rem;\n\n    ion-input {\n      width: 82%;\n      border: none;\n      padding: 5px 10px;\n      color: #8a898b;\n      font-size: 14px;\n      font-weight: bold;\n      font-family: 'Titillium Web', sans-serif;\n      background: inherit;\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    button {\n      width: 18%;\n      border: none;\n      color: #8a898b;\n      opacity: 0.9;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n      background: inherit;\n\n      ion-icon {\n        font-size: 1.5rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
